import { render, staticRenderFns } from "./tradeRight.vue?vue&type=template&id=4a0bfd41&scoped=true&"
import script from "./tradeRight.vue?vue&type=script&lang=js&"
export * from "./tradeRight.vue?vue&type=script&lang=js&"
import style0 from "./tradeRight.vue?vue&type=style&index=0&id=4a0bfd41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0bfd41",
  null
  
)

export default component.exports